// extracted by css-extract-rspack-plugin
export default {"tableQuickFiltersSectionHeader":"TableQuickFiltersSectionHeader_tableQuickFiltersSectionHeader__NK4-0"};